// App.tsx veya bir layout component içinde
import { useEffect } from "react";
import { getOrCreateVisitorId } from "@/utils/visitor";
import { useLocation } from "react-router-dom";
import { logger } from "@/lib/default-logger";

const TrackVisitor = () => {
  const location = useLocation();
  useEffect(() => {
    const endpoint = location.pathname;
    logger.log(endpoint);
    const visitorId = getOrCreateVisitorId();
    fetch(`${process.env.REACT_APP_SERVER_URL}/visitor/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ visitorId, path: endpoint }),
    });
  }, []);
  return null;
};

export default TrackVisitor;
